module.exports = __webpack_public_path__ + "img/20191008160439466.de7545aa.jpg";